import type { ReactNode } from 'react';
import { cn } from './cn.js';

export type Tone = 'neutral' | 'navy' | 'azur' | 'success' | 'warn' | 'danger';

export const TONES: Record<Tone, string> = {
  neutral: 'bg-surface-2 text-ink-2 border-line-soft',
  navy: 'bg-navy-50 text-navy-600 border-navy-100',
  azur: 'bg-azur-50 text-azur-700 border-azur-100',
  success: 'bg-success-50 text-success-700 border-success-100',
  warn: 'bg-warn-50 text-warn-700 border-warn-100',
  danger: 'bg-danger-50 text-danger-700 border-danger-100',
};

const DOTS: Record<Tone, string> = {
  neutral: 'bg-gray-500',
  navy: 'bg-navy-600',
  azur: 'bg-azur-500',
  success: 'bg-success-600',
  warn: 'bg-warn-600',
  danger: 'bg-danger-600',
};

/** Badge en pastille. `dot` ajoute la puce ronde, rappel des pastilles du logo. */
export function Badge({
  tone = 'neutral',
  dot,
  children,
  className,
  title,
}: {
  tone?: Tone;
  dot?: boolean;
  children: ReactNode;
  className?: string;
  title?: string;
}) {
  return (
    <span
      title={title}
      className={cn(
        'inline-flex items-center gap-1.5 whitespace-nowrap rounded-pill border px-2 py-0.5 text-[12px] font-semibold leading-5',
        TONES[tone],
        className,
      )}
    >
      {dot && <span aria-hidden className={cn('h-1.5 w-1.5 rounded-pill', DOTS[tone])} />}
      {children}
    </span>
  );
}
